import React from "react"
import { ButtonLoadingSeeker, ButtonSeeker } from "@ui-seeker/core"

import { useCommonFilter } from "@hooks"
import { isLoadingCommonFilters, resetCommonFilters } from "@signals"


export default function CommonFiltersFooterActions(
	{
		onSubmit = null,
		schema = null,
		isValid,
		isLoading,
		...props
	}) {
	const { disableButton, handleSubmit } = useCommonFilter(isValid)

	return <ButtonLoadingSeeker
		loading={isLoadingCommonFilters.value || isLoading}
		sx={{ px: 4 }}
		onClick={() => handleSubmit(onSubmit, schema)}
		disabled={disableButton}
		{...props.loadingProps}
	>
		Search
	</ButtonLoadingSeeker>
}